import { IIndex } from '@syncfusion/ej2-react-grids';
import { useState } from 'react';
import { focusCellByIndex, focusOnButtonContainedByCell } from '../utils/TableUtils';

export const usePersistFocusInTable = () => {
    const [selectedCellIndex, setSelectedCellIndex] = useState<IIndex | undefined>(undefined);

    const focusOnSelectedCell = (focusOnChild: boolean = true) => {
        if (selectedCellIndex) {
            if (focusOnChild) {
                focusOnButtonContainedByCell(selectedCellIndex);
            } else {
                focusCellByIndex(selectedCellIndex);
            }

            setSelectedCellIndex(undefined);
        }
    };

    return { selectedCellIndex, setSelectedCellIndex, focusOnSelectedCell };
};
